var app = angular.module("leonardo");

var ContactStates = function($stateProvider) {
  $stateProvider.state('contacts', {
    url: '/contacts',
    parent: 'authenticated.layout-main',
    redirectTo: function (PermissionService) {
      let user = PermissionService.authDataService.authData.user;
      if (user && (!user.is_staff && !user.is_white_label_admin)) {
        return 'contacts.list';
      }
      else {
        return 'contacts.types';
      }
    },
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    ncyBreadcrumb: {
      label: 'Contacts'
    }
  });

  $stateProvider.state('contacts.list', {
    url: "/list",
    title: 'Contacts',
    only_filter_account: true,
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'ContactListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/contact/list.html',
        controller: 'ContactListController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/contact-list.html',
        controller: 'ContactListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Contacts List'
    }
  });

  $stateProvider.state('contacts.types', {
    url: "/types",
    title: 'Contact Types',
    views: {
      'filters@authenticated.layout-main': {
        templateUrl: 'views/templates/filter/filters-base.html',
        controller: 'ContactTypeListFilters'
      },
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/contact/type-list.html',
        controller: 'ContactTypeListController'
      },
      'actions@authenticated.layout-main': {
        templateUrl: 'views/templates/actions/contact-type-list.html',
        controller: 'ContactTypeListActions'
      }
    },
    ncyBreadcrumb: {
      label: 'Contact Types'
    }
  });
};

app.config(['$stateProvider', ContactStates]);
